export default __webpack_public_path__ + "static/media/Tropical.5757b5be.svg";